import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ab70336"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Profile Overview")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Change password")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Your Plan")
], -1))
const _hoisted_4 = {
  key: 1,
  class: "colored-bg full-height"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "flex-desktop" }
const _hoisted_7 = { class: "full-width" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Profile Overview", -1))
const _hoisted_9 = { class: "full-width" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Change password", -1))
const _hoisted_11 = { style: {"margin":"30px 80px"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Your Plan", -1))
const _hoisted_13 = { class: "container" }

import { save } from "ionicons/icons";
import {
  IonInput,
  IonPage,
  IonButton,
  IonNote,
  IonLoading,
  IonFooter,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  onIonViewWillEnter,
  useIonRouter,
  IonAlert,
  isPlatform,
  getPlatforms,
} from "@ionic/vue";
import { computed, reactive } from "vue";
import { useWindowWidth } from "@/composition/window";
import { useMyAccount } from "../";
import { editPassword, editUser, requireDeleteUser } from "@/api/users";
import { useUserStore } from "@/stores/user";
import { useToasters } from "@/composition/toasters";
import { handleError } from "@/views";
import BeamianPlan from "@/views/_partials/BeamianPlan.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyAccount',
  setup(__props) {

const { isMobile } = useWindowWidth();
const { form } = useMyAccount();

const state = reactive({
  loading: false,
  errors: {
    name: [],
  },
  client_account: {},
  total_visitors: 0,
  alertDeleteAccount: false,
  plataform: "",
});

const toasters = useToasters();

const userStore = useUserStore();

const router = useIonRouter();

const emptyFieldsPresent = computed(
  () =>
    form.name === "" ||
    (form.new_password !== "" && form.confirm_password === form.new_password)
);

// const deleteUserPrompt = async () => {
//   const alert = await alertController.create({
//     header: "Are you sure?",
//     buttons: [
//       {
//         text: "Cancel",
//         role: "cancel",
//       },
//       {
//         text: "Delete",
//         role: "confirm",
//         handler: () => {
//           deleteUser(userStore.me)
//             .then(() => {
//               toasters.addSuccess(`Your account was deleted successfuly`);
//               router.push(`/onboarding/introduction`);
//               alert.remove();
//             })
//             .catch((err) => {
//               if (err.response.data.detail) {
//                 toasters.addError(err.response.data.detail);
//               } else {
//                 toasters.addError(
//                   `Failed to delete your account. Please try again later.`
//                 );
//               }
//               alert.remove();
//             });
//         },
//       },
//     ],
//   });

//   await alert.present();
// };

const deleteAccountButtons = [
  {
    text: "Cancel",
    role: "cancel",
    cssClass: "alert-button-cancel",
    handler: () => {
      state.alertDeleteAccount = false;
    },
  },
  {
    text: " OK ",
    role: "confirm",
    cssClass: "alert-button-confirm",
    handler: () => {
      state.alertDeleteAccount = false;
      // call delete request
      requireDeleteUser(userStore.me.id, { origin: state.plataform })
        .then(() => {
          toasters.addSuccess(
            "Request received. Your account will be deleted soon."
          );
          setTimeout(() => {
            userStore.setUserLogout();
            router.push("/login");
          }, 1500);
        })
        .catch((err) => {
          state.alertDeleteAccount = false;
          handleError(err);
        });
    },
  },
];

onIonViewWillEnter(() => {
  form.email = userStore.me.email || "";
  form.name = userStore.me.name || "";
  getContextPlatform();
});

const getContextPlatform = () => {
  if (isPlatform("ios")) {
    state.plataform = "iOS";
  }
  if (isPlatform("android")) {
    state.plataform = "Android";
  }
  if (!state.plataform && getPlatforms().includes("desktop")) {
    state.plataform = "desktop";
  }
};

const update = () => {
  state.loading = true;
  const user = {
    id: userStore.me.id,
    name: form.name,
    email: userStore.me.email,
  };
  editUser(user)
    .then(() => {
      state.loading = false;
      toasters.addSuccess("Your user data has been changed.");
    })
    .catch((err) => {
      state.loading = false;
      handleError(err);
    });

  if (form.password !== "") {
    editPassword(form.password)
      .then(() => {
        state.loading = false;
        toasters.addSuccess("Your password has been changed.");
      })
      .catch((err) => {
        state.loading = false;
        handleError(err);
      });
  }
};

const updateUser = (field: string, event: any) => {
  const updatedValue = event.detail.value;

  if (field === "name") {
    form.name = updatedValue;
  }
  if (field === "email") {
    form.email = updatedValue;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonContent), { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("section", null, [
                _hoisted_1,
                _createVNode(_unref(IonList), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "stacked" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Name")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonInput), {
                          modelValue: _unref(userStore).me.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(userStore).me.name) = $event)),
                          placeholder: "John Doe",
                          onIonChange: _cache[1] || (_cache[1] = ($event: any) => (updateUser('name', $event)))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "stacked" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Email")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonInput), {
                          type: "email",
                          modelValue: _unref(userStore).me.email,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userStore).me.email) = $event)),
                          placeholder: "john.doe@gmail.com",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_2,
                _createVNode(_unref(IonList), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "stacked" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Current password")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonInput), {
                          type: "password",
                          modelValue: _unref(form).current_password,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).current_password) = $event)),
                          placeholder: "********"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "stacked" }, {
                          default: _withCtx(() => [
                            _createTextVNode("New password")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonInput), {
                          type: "password",
                          modelValue: _unref(form).new_password,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).new_password) = $event)),
                          placeholder: "********"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), {
                      class: _normalizeClass({
            'ion-invalid':
              _unref(form).new_password !== '' &&
              _unref(form).new_password !== _unref(form).confirm_password,
          })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "stacked" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Confirm password")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonInput), {
                          type: "password",
                          modelValue: _unref(form).confirm_password,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).confirm_password) = $event)),
                          placeholder: "********"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_unref(IonNote), { slot: "error" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Passwords do not match ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                }),
                _hoisted_3,
                _createVNode(BeamianPlan),
                _createVNode(_unref(IonRow), { class: "ion-justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonButton), {
                      fill: "outline",
                      size: "small",
                      color: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (state.alertDeleteAccount = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Delete Account")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonAlert), {
                  isOpen: state.alertDeleteAccount,
                  buttons: deleteAccountButtons,
                  header: "Are you sure?",
                  message: "This will permanently delete your account."
                }, null, 8, ["isOpen"])
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_unref(IonList), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Name")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            modelValue: _unref(userStore).me.name,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(userStore).me.name) = $event)),
                            placeholder: "John Doe",
                            onIonChange: _cache[8] || (_cache[8] = ($event: any) => (updateUser('name', $event)))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Email")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            type: "email",
                            modelValue: _unref(userStore).me.email,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(userStore).me.email) = $event)),
                            placeholder: "john.doe@gmail.com",
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_unref(IonList), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Current password")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            type: "password",
                            modelValue: _unref(form).current_password,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).current_password) = $event)),
                            placeholder: "********"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode("New password")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            type: "password",
                            modelValue: _unref(form).new_password,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).new_password) = $event)),
                            placeholder: "********"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), {
                        class: _normalizeClass({
                'ion-invalid':
                  _unref(form).new_password !== '' &&
                  _unref(form).new_password !== _unref(form).confirm_password,
              })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Confirm password")
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonInput), {
                            type: "password",
                            modelValue: _unref(form).confirm_password,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).confirm_password) = $event)),
                            placeholder: "********"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_unref(IonNote), { slot: "error" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Passwords do not match ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(BeamianPlan),
                _createVNode(_unref(IonRow), { class: "ion-justify-content-center ion-margin-top" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonButton), {
                      fill: "outline",
                      size: "small",
                      color: "primary",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (state.alertDeleteAccount = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Delete Account")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonAlert), {
                      isOpen: state.alertDeleteAccount,
                      buttons: deleteAccountButtons,
                      header: "Are you sure?",
                      message: "This will permanently delete your account."
                    }, null, 8, ["isOpen"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 2 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("section", null, [
                  _createVNode(_unref(IonGrid), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonButton), {
                                expand: "block",
                                color: "light",
                                onClickp: _cache[14] || (_cache[14] = ($event: any) => (_unref(router).back()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "start",
                                    icon: _unref(save)
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" Cancel ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonButton), {
                                expand: "block",
                                color: "success",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (update())),
                                disabled: emptyFieldsPresent.value
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "start",
                                    icon: _unref(save)
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" Save ")
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})